"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _HeaderActions = _interopRequireDefault(require("../HeaderActions"));
var _NavItem = _interopRequireDefault(require("../Navbar/NavItem"));
var _MobileHeaderModule = _interopRequireDefault(require("./MobileHeader.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MobileHeader = _ref => {
  let {
    isLoggedIn,
    mobileNavLinks,
    mobileDropDown,
    LoggedInActions,
    LoggedOutActions,
    color
  } = _ref;
  const [openMobileMenu, setOpenMobileMenu] = (0, _react.useState)(false);
  const stopProgationOfEventToHeader = e => {
    e.stopPropagation();
  };
  const toggleMobileMenu = e => {
    stopProgationOfEventToHeader(e);
    setOpenMobileMenu(!openMobileMenu);
  };
  if (!openMobileMenu) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${_MobileHeaderModule.default.hamburger} ${color === "white" && _MobileHeaderModule.default.whiteHamburger}`,
      onClick: toggleMobileMenu
    }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${_MobileHeaderModule.default.mobileNavContainer} ${color === "white" && _MobileHeaderModule.default.whiteHeader}`,
    onClick: stopProgationOfEventToHeader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MobileHeaderModule.default.closeMenuIcon
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    onClick: toggleMobileMenu
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: _MobileHeaderModule.default.mobileNavigation
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: `${isLoggedIn ? null : _MobileHeaderModule.default.hideNav} ${color === "white" && _MobileHeaderModule.default.whiteHeader}`
  }, mobileNavLinks && mobileNavLinks.map(tab => /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    key: tab.label,
    title: tab.label,
    link: tab.to,
    active: tab.active
  })), mobileDropDown && mobileDropDown.map(dropdown => /*#__PURE__*/_react.default.createElement("div", {
    key: dropdown.label,
    className: _MobileHeaderModule.default.subMenues
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    title: dropdown.label,
    subHeader: true
  }), dropdown.list.map(item => /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    key: item.label,
    title: item.label,
    link: item.link,
    subListItem: true
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _MobileHeaderModule.default.mobileActionBtns
  }, /*#__PURE__*/_react.default.createElement(_HeaderActions.default, {
    isLoggedIn: isLoggedIn,
    LoggedInActions: LoggedInActions,
    LoggedOutActions: LoggedOutActions,
    headerType: "mobile"
  }))));
};
var _default = exports.default = MobileHeader;